import { gql } from '@apollo/client';

export default gql`
  mutation createVacation(
    $branch: String
    $time: Date
    $title: String
    $desc: String
    $status: Int # 2 "active", 10 10 "Not Active"
    $employeeId: String
    $employeeName: String
    $employeeNameAr: String
    $startDate: Date
    $endDate: Date
    $userId: String
    $note: String
  ) {
    createVacation(
      branch: $branch
      time: $time
      title: $title
      desc: $desc
      status: $status
      employeeId: $employeeId
      employeeName: $employeeName
      employeeNameAr: $employeeNameAr
      startDate: $startDate
      endDate: $endDate
      userId: $userId
      note: $note
    ) {
      ok
      message
      data
      error
    }
  }
`;
